import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import './index.css';
import './animations.css';
import App from './App';
import './erp-shell.css';
import { installerIntercepteur401 } from './services/authInterceptor';
import { installerCleLecture } from './services/cleLecture';

// Avant le premier rendu : tout appel, de n'importe quel écran, passe dessous.
installerIntercepteur401();
// La clé de lecture des documents : jamais le jeton de session dans une adresse (28.09).
installerCleLecture();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>
);